import React from "react";
import { Link } from "react-router-dom";
const Header = ({ showHeader }) => {
  if (!showHeader) return null;

  return (
    <div className="header-container">
          <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna"> Lookna </span><br></br><br></br>
              
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
  
            </h2>
          
          </div>
          <div className="details-borders"></div>
       
        </div>
      {/* <div style={{height: "90px"}}></div> */}
      {/* <div className="details-borders"></div> */}
    </div>
  );
};

export default Header;
